import React from 'react';
import { Currency } from '../../../common/format';
import { CurrencySwitch } from './currency-switch';

interface CurrencyHeaderProps {
  title?: string;
  ufValue: number;
  currency: Currency;
  onCurrencyChange: (c: Currency) => void;
}

export function CurrencyHeader({
  title = 'Resultado',
  ufValue,
  currency,
  onCurrencyChange,
}: CurrencyHeaderProps) {
  return (
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h2 className="h5 mb-0">{title}</h2>
      <div className="d-flex align-items-center gap-2">
        <span className="small text-muted">
          1 UF = ${ufValue.toLocaleString('es-CL')}
        </span>
        <CurrencySwitch value={currency} onChange={onCurrencyChange} />
      </div>
    </div>
  );
}
